import { SiManageiq } from "react-icons/si";
import styles from "../bussiness.module.css";

import { AiOutlinePlus } from "react-icons/ai";
import "../cstyle.css";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
// import ManagementSidebar from "../ManagementSidebar/ManagementSidebar";

import Product from "./Product";
import OptionModal from "./OptionModal";

const ProductPage = ({ accessLevel }) => {
  return (
    <div className=" w-100 mt-2 d-flex" style={{ height: "96%" }}>
      {/* <ManagementSidebar></ManagementSidebar> */}
      <div className="container">
        <div className=" d-flex mx-3 justify-content-end">
          <>
            {accessLevel.includes(100) && (
              <button
                className={`btn  mx-1 mt-3 ${styles.btnHov}`}
                id=""
                style={{ background: "#CCEEF0", border: "#5EAAB7 1px solid" }}
                data-bs-toggle="modal"
                data-bs-target="#exampleModalAddProduct"
              >
                <div className="d-flex justify-content-around align-items-center text-center">
                  <AiOutlinePlus />
                  <p
                    className="textPro"
                    style={{ marginBottom: "0px", marginRight: "3px" }}
                  >
                    {" "}
                    افزودن محصول
                  </p>
                </div>
              </button>
            )}
            {/* <AddProduct updater={true}/> */}
            {accessLevel.includes(102) && (
              <button
                className={`btn  mx-1 mt-3 ${styles.btnHov4}`}
                id=""
                style={{ background: "#DAFFE6", border: "#20A740 1px solid" }}
                data-bs-toggle="modal"
                data-bs-target="#OptionModal"
              >
                <div className="d-flex justify-content-around align-items-center text-center">
                  <SiManageiq />
                  <p
                    className="textPro"
                    style={{ marginBottom: "0px", marginRight: "3px" }}
                  >
                    {" "}
                    مدیریت آپشن ها
                  </p>
                </div>
              </button>
            )}
            {/* <button className="btn btn-danger mx-1 mt-3" id="">
              <div className="d-flex justify-content-around align-items-center text-center">
                <FaTrashAlt />
                <p
                  className="textPro"
                  style={{ marginBottom: "0px", marginRight: "3px" }}
                >
                  {" "}
                  حذف فیلتر
                </p>
              </div>
            </button> */}
            {accessLevel.includes(100) && (
              <button
                className={`btn text-white  mx-1 mt-3 ${styles.btnHov3}`}
                id=""
                style={{ background: "#1A3764" }}
                data-bs-toggle="modal"
                data-bs-target="#filterModalProduct"
              >
                <div className="d-flex justify-content-around align-items-center text-center">
                  <FaFilter />
                  <p
                    className="textPro"
                    style={{ marginBottom: "0px", marginRight: "3px" }}
                  >
                    {" "}
                    فیلتر محصول
                  </p>
                </div>
              </button>
            )}
            <OptionModal />
          </>
        </div>
        {accessLevel.includes(100) && <Product />}
      </div>
    </div>
  );
};

export default ProductPage;
